import { render, staticRenderFns } from "./SettingsUser.vue?vue&type=template&id=cef35e6a"
import script from "./SettingsUser.vue?vue&type=script&lang=js"
export * from "./SettingsUser.vue?vue&type=script&lang=js"
import style0 from "./SettingsUser.vue?vue&type=style&index=0&id=cef35e6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports